//document.onreadystatechange = () => {
//document.onreadystatechange = function () {
$(document).on('readystatechange', function () {

    if (document.readyState === 'complete') {

        if (window.location.pathname === '/plp/add') {
            //variable declaration
            let addmyplp = document.querySelector('.btn-add-plp');
            let count = 1;
            addnewplp(count);
            //Event Listeners

            //Funtions

            function increaseCount() {
                count++;
            }

            function addnewplp(number) {
                let obj = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                let focus = ['', 'Independence', 'Fluency', 'Maintenance', 'Generalisation'];
                let focus_area_id = ['', 'Communication & Interaction', 'Sensory and Physical Needs', 'Social, Emotional Wellbeing', 'Cognition and Learning', 'Participation', 'Independent Living', 'Community Inclusion', 'Health Pathway',];
                let html = `<hr>
                <div id="target-${number}" class="plp-target">


                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label"><h3> PLP Focus ${number} </h3></label>
                    <div class="col-md-18">
                        <select id="focus_area_id_${number}" class="select2 full-width focus-areas" name="plp_focus_area_id_${number}" >
                        
                    ${Object.keys(focus_area_id).map(function (key) {
                    return "<option value='" + focus_area_id[key] + "'>" + focus_area_id[key] + "</option>"
                }).join("")}
                           
             
                        </select>
                        
                    </div>
                    <div class="full-width">
                    <textarea class="form-control strategy" name="plp_focus_area_${number}" placeholder="Please enter focus details. You can copy and paste from your PLP word document to here."></textarea>
                    </div>
                </div>
                
                <h5>Learning Intention - Independence  </h5>
                
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Baseline </label>
                    <div class="col-md-18">
                        <select id="baseline_${number}" class="select2 full-width focus-areas" name="plp_baseline_independence_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Predicted Progress </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_predicted_independence_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                 <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Progress Made </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_progress_independence_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>    <h5>Learning Intention - Fluency  </h5>
                
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Baseline </label>
                    <div class="col-md-18">
                        <select id="baseline_${number}" class="select2 full-width plp-focus-areas" name="plp_baseline_fluency_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Predicted Progress </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_predicted_fluency_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                 <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Progress Made </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_progress_fluency_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>    <h5>Learning Intention - Maintenance  </h5>
                
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Baseline </label>
                    <div class="col-md-18">
                        <select id="baseline_${number}" class="select2 full-width plp-focus-areas" name="plp_baseline_maintenance_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                    
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Predicted Progress </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_predicted_maintenance_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                 <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Progress Made </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_progress_maintenance_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>    
                <br>
                
                <h5>Learning Intention - Generalisation  </h5>
                
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Baseline </label>
                    <div class="col-md-18">
                        <select id="baseline_${number}" class="select2 full-width plp-focus-areas" name="plp_baseline_generalisation_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Predicted Progress </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_predicted_generalisation_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                 <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Progress Made </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_progress_generalisation_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                    `;
                if (number <= 1) {
                    html += `
                                <div class="form-group row" id="add-container">
                                    <div class="offset-md-6 col-md-18">
                                        <a class="btn btn-primary btn-add-plp ">+ Add Focus</a>
                                    </div>
                                </div>
                `;
                    $('.plp-targets').html(html)

                } else {
                    html += `
                                <div class="form-group row" id="add-container">
                                <div class="offset-md-6 col-md-18">
                                <a class="btn btn-primary btn-add-plp">+ Add Focus</a>
                                <a id="remove" class="btn btn-link text-danger btn-remove-plp">x Remove <?= $translatedTarget; ?></a>
                                </div>
                                </div>
                                </div>
                               `;
                    $('.plp-targets').append(html)
                }


            }

            //
            // $('.btn-add-plp').click(function () {
            //     if (count <= 7) {
            //         count++;
            //         addnewplp(count);
            //     }else {
            //         alert('You cant have more than 8')
            //     }
            // });
            $(document).on('click', '.btn-add-plp', function (e) {
                if (count <= 7) {
                    count++;
                    addnewplp(count);
                } else {
                    alert('You cant have more than 8')
                }

            });

            $(document).on('click', '.btn-remove-plp', function (e) {
                count--;
                e.target.parentElement.parentElement.parentElement.remove();
                // console.log(e)

            });


        }
        $('.add-plp-property').click(function (e) {
            // console.log('working');
            var property = $(this).data('property');
            console.log(property);
            var name = $('#' + property).val();
            if (property == 'focus-area-id') {
                var translatedProperty = 'Focus Area';
                $.get('/plp/' + property + '/add?name=' + name, function (data) {
                    if (data.success) {
                        alert(translatedProperty + ' added successfuly!');
                        $('#' + property + '-modal').modal('hide');
                        Plp.bindPropertySelect();
                    } else {
                        alert('Action not successful, please try again.');
                    }
                });
            }
        });


        if (window.location.pathname.match(/^\/plp\/\d+\/edit$/) != null) {
            //alert(window.location.pathname.match(/^\/plp\/\d+\/edit$/));
            //variable declaration
            let editaddmyplp = document.querySelector('.btn-edit-add-plp');
            var count = 0;
            $('h3.plp-focus-head').each(function () {
                count = $(this).text().match(/\d+/)[0];
            });
            count++;
            //let count = 0;
            let initial = true;
            editaddnewplp(count, initial);
            //Event Listeners

            //Funtions

            function increaseCount() {
                count++;
            }

            function editaddnewplp(number, firstPass) {
                let obj = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                let focus = ['', 'Independence', 'Fluency', 'Maintenance', 'Generalisation'];
                let focus_area_id = ['', 'Communication & Interaction', 'Sensory and Physical Needs', 'Social, Emotional Wellbeing', 'Cognition and Learning', 'Participation', 'Independent Living', 'Community Inclusion', 'Health Pathway',];
                let html = `<hr>
                <div id="target-${number}" class="plp-target">


                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label"><h3 class="plp-focus-head"> PLP Focus ${number} </h3></label>
                    <div class="col-md-18">
                        <select id="focus_area_id_${number}" class="select2 full-width focus-areas" name="plp_focus_area_id_${number}" >
                        
                    ${Object.keys(focus_area_id).map(function (key) {
                    return "<option value='" + focus_area_id[key] + "'>" + focus_area_id[key] + "</option>"
                }).join("")}
                           
             
                        </select>
                        
                    </div>
                    <div class="full-width">
                    <textarea class="form-control strategy" name="plp_focus_area_${number}" placeholder="Please enter focus details. You can copy and paste from your PLP word document to here."></textarea>
                    </div>
                </div>
                
                <h5>Learning Intention - Independence  </h5>
                
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Baseline </label>
                    <div class="col-md-18">
                        <select id="baseline_${number}" class="select2 full-width focus-areas" name="plp_baseline_independence_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Predicted Progress </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_predicted_independence_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                 <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Progress Made </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_progress_independence_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>    <h5>Learning Intention - Fluency  </h5>
                
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Baseline </label>
                    <div class="col-md-18">
                        <select id="baseline_${number}" class="select2 full-width plp-focus-areas" name="plp_baseline_fluency_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Predicted Progress </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_predicted_fluency_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                 <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Progress Made </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_progress_fluency_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>    <h5>Learning Intention - Maintenance  </h5>
                
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Baseline </label>
                    <div class="col-md-18">
                        <select id="baseline_${number}" class="select2 full-width plp-focus-areas" name="plp_baseline_maintenance_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                    
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Predicted Progress </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_predicted_maintenance_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                 <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Progress Made </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_progress_maintenance_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>    
                <br>
                
                <h5>Learning Intention - Generalisation  </h5>
                
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Baseline </label>
                    <div class="col-md-18">
                        <select id="baseline_${number}" class="select2 full-width plp-focus-areas" name="plp_baseline_generalisation_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Predicted Progress </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_predicted_generalisation_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                 <div class="form-group row" >
                    <label for="" class="col-md-6 col-form-label">Progress Made </label>
                    <div class="col-md-18">
                        <select id="score_${number}" class="select2 full-width plp-focus-areas" name="plp_progress_generalisation_${number}" >
                            
                            ${Object.keys(obj).map(function (key) {
                    return "<option value='" + key + "'>" + obj[key] + "</option>"
                }).join("")}
                            
                        </select>
                    
                        <a class="edit-add-plp-property"></a>
                        <?php endif; ?>
                        <a class="manage-plp-property" ></a>
                    </div>
                </div>
                
                    `;
                if (number < 8) {
                    //alert('number='+number+' firstPass='+firstPass);
                    if (firstPass) {
                        html = `
                                <div class="form-group row" id="add-container">
                                    <div class="offset-md-6 col-md-18">
                                        <a class="btn btn-primary btn-edit-add-plp ">+ Add Focus</a>
                                    </div>
                                </div>
                `;
                        $('.plp-targets').html(html)

                    } else {
                        html += `
                                <div class="form-group row" id="add-container">
                                <div class="offset-md-6 col-md-18">
                                <a class="btn btn-primary btn-edit-add-plp">+ Add Focus</a>
                                <a id="remove" class="btn btn-link text-danger btn-edit-remove-plp">x Remove <?= $translatedTarget; ?></a>
                                </div>
                                </div>
                                </div>
                               `;
                        $('.plp-targets').append(html)
                    }
                }


            }

            //
            // $('.btn-edit-add-plp').click(function () {
            //     if (count <= 7) {
            //         count++;
            //         editaddnewplp(count);
            //     }else {
            //         alert('You cant have more than 8')
            //     }
            // });
            $(document).on('click', '.btn-edit-add-plp', function (e) {
                if (count <= 7) {
                    initial = false;
                    editaddnewplp(count, initial);
                    count++;
                    $('.select2').select2();
                } else {
                    alert('You cant have more than 8')
                }

            });

            $(document).on('click', '.btn-edit-remove-plp', function (e) {
                count--;
                e.target.parentElement.parentElement.parentElement.remove();
                // console.log(e)

            });


        }
        $('.edit-add-plp-property').on('click', function (e) {
            // console.log('working');
            var property = $(this).data('property');
            console.log(property);
            var name = $('#' + property).val();
            if (property == 'focus-area-id') {
                var translatedProperty = 'Focus Area';
                $.get('/plp/' + property + '/add?name=' + name, function (data) {
                    if (data.success) {
                        alert(translatedProperty + ' added successfuly!');
                        $('#' + property + '-modal').modal('hide');
                        Plp.bindPropertySelect();
                    } else {
                        alert('Action not successful, please try again.');
                    }
                });
            }
        });
    }


});